// extracted by mini-css-extract-plugin
module.exports = {"default":"style_default__2M60S"};